<template>
  <div class="finish" :class="{ 'finish--won': game.result?.won }">
    <span class="finish__kicker">{{ game.result?.won ? 'The commonwealth is remembered' : 'The commonwealth has fallen' }}</span>
    <h2 class="finish__title">{{ title }}</h2>
    <p class="finish__text">{{ text }}</p>
    <dl class="finish__stats">
      <div><dt>Years</dt><dd>{{ years }}</dd></div>
      <div><dt>Wonders</dt><dd>{{ (game.civ.wonders || []).length }}</dd></div>
      <div><dt>Technologies</dt><dd>{{ game.civ.techs.length }}</dd></div>
      <div><dt>Regions</dt><dd>{{ game.civ.regions.length }}</dd></div>
      <div><dt>Tales</dt><dd>{{ (game.civ.tales || []).length }}</dd></div>
    </dl>
    <slot />
  </div>
</template>

<script>
import { LOSS } from '@/engine/constants';
import { GOALS, goalOf } from '@/engine/cards';
import { VICTORIES } from '@/engine/victory';
import { yearOf } from '@/engine/calendar';

const ENDINGS = {
  ...Object.fromEntries(Object.entries(GOALS).map(([id, g]) => [id, g.ending])),
  ...Object.fromEntries(Object.entries(VICTORIES).map(([id, v]) => [id, [`Victory: ${v.name}`, v.text]])),
  [LOSS.REVOLT]: ['Revolt', 'Happiness reached 0 and the people revolted.'],
  [LOSS.COLLAPSE]: ['Collapse', 'The last of the people are gone.'],
  [LOSS.SACKED]: ['Sacked', 'Raiders reached the city with nothing left standing.'],
  [LOSS.OUTPACED]: ['Outpaced', 'Another people raised their wonders first.'],
};

export default {
  name: 'FinishPanel',
  props: { game: { type: Object, required: true } },
  computed: {
    goal() { return GOALS[goalOf(this.game.civ)] || null; },
    title() { return ENDINGS[this.game.result?.reason]?.[0] || 'The End'; },
    text() {
      const t = ENDINGS[this.game.result?.reason]?.[1] || '';
      return this.game.result?.reason === LOSS.OUTPACED && this.game.result?.by ? t.replace('Another people', this.game.result.by) : t;
    },
    years() { return yearOf(this.game.meta.round); },
  },
};
</script>
